import React, { useEffect } from "react";

const SimpleAccessibility: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    // רק הוספת skip link
    const addSkipLink = () => {
      if (!document.getElementById("skip-to-main")) {
        const skipLink = document.createElement("a");
        skipLink.id = "skip-to-main";
        skipLink.href = "#main-content";
        skipLink.textContent = "דלג לתוכן הראשי";
        skipLink.style.cssText = `
          position: absolute;
          top: -40px;
          left: 6px;
          background: #000;
          color: #fff;
          padding: 8px;
          text-decoration: none;
          z-index: 10000;
          transition: top 0.3s;
          border-radius: 4px;
        `;
        skipLink.addEventListener("focus", () => {
          skipLink.style.top = "6px";
        });
        skipLink.addEventListener("blur", () => {
          skipLink.style.top = "-40px";
        });
        document.body.insertBefore(skipLink, document.body.firstChild);
      }
    };

    // רק הוספת alt tags לתמונות
    const addAltTags = () => {
      const images = document.querySelectorAll("img:not([alt]), img[alt='']");
      images.forEach((img, index) => {
        if (!img.getAttribute("alt")) {
          const src = img.getAttribute("src") || "";
          const fileName =
            src.split("/").pop()?.split(".")[0] || `תמונה ${index + 1}`;
          img.setAttribute("alt", fileName);
        }
      });
    };

    // רק הוספת main landmark פשוט
    const addMainLandmark = () => {
      const mainContent =
        document.querySelector("main") || document.querySelector("#root");
      if (mainContent && !mainContent.getAttribute("role")) {
        mainContent.id = "main-content";
      }
    };

    // הוספת focus indicators לכל האלמנטים שניתן להתמקד בהם
    const addFocusIndicators = () => {
      // לא צריך להוסיף tabindex - אלמנטים אינטראקטיביים כבר focusable
      // לא מוסיפים tabindex לטקסטים - זה מפר את התקן
      // Focus styles מטופלים ב-accessibility.css עם :focus-visible
    };

    // הפעלה ראשונית
    addSkipLink();
    addAltTags();
    addMainLandmark();
    addFocusIndicators();

    // הפעלה מחדש כשהתוכן משתנה
    const observer = new MutationObserver(() => {
      addAltTags();
      addFocusIndicators();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return <>{children}</>;
};

export default SimpleAccessibility;
